export const NAVIGATION_CHANGE_PAGE = 'NAVIGATION_CHANGE_PAGE';
export const HORIZHEIGHT_DETERMINDED = 'HORIZHEIGHT_DETERMINDED';
